import { twMerge } from "@/utils/twMerge";

import type { DOMOutputSpec } from "@tiptap/pm/model";

export function button(
  { class: className, ...attrs }: Record<string, string> = {},
  ...children: (DOMOutputSpec | string)[]
): DOMOutputSpec {
  return [
    "button",
    {
      type: "button",
      tabindex: "-1",
      class: twMerge(
        "flex items-center justify-center w-6 h-6 py-0.5 shrink-0 select-none cursor-pointer relative",
        "rounded-6 transition-colors",
        "text-sm tracking-tight",
        "hover:bg-sidebar-button-hover-bg",
        className,
      ),
      ...attrs,
    },
    ...children,
  ];
}
